// extracted by mini-css-extract-plugin
module.exports = {"buttons":"LinkedSuccessfullyModal_buttons__29W5K"};